// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports-container {
  height: calc(100% - 8rem);
}

.report-save-button-container {
  display: flex;
  justify-content: flex-end;
  margin-right: 5rem;
}

.report-table {
  margin: 1rem;
  overflow: auto;
  height: calc(100% - 9rem - 1px);
}

.report-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 2px;
  background-color: white;
  box-shadow: inset 0px 0px 1px 0px black;
}

.report-table thead th .header-item {
  margin: 0.5rem 1rem;
}

.report-table thead th::first-letter {
  text-transform: uppercase;
}

.report-table td {
  vertical-align: top;
  max-width: 40rem;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-height: 10rem;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/app/analytics/analytics-main/analytics-tabs/reports/Reports.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".reports-container {\r\n  height: calc(100% - 8rem);\r\n}\r\n\r\n.report-save-button-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-right: 5rem;\r\n}\r\n\r\n.report-table {\r\n  margin: 1rem;\r\n  overflow: auto;\r\n  height: calc(100% - 9rem - 1px);\r\n}\r\n\r\n.report-table thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n  padding: 2px;\r\n  background-color: white;\r\n  box-shadow: inset 0px 0px 1px 0px black;\r\n}\r\n\r\n.report-table thead th .header-item {\r\n  margin: 0.5rem 1rem;\r\n}\r\n\r\n.report-table thead th::first-letter {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.report-table td {\r\n  vertical-align: top;\r\n  max-width: 40rem;\r\n  word-wrap: break-word;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-height: 10rem;\r\n  position: relative;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
